import {inject} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {CanDeactivateFn} from '@angular/router';
import { ConfirmModalComponent } from 'jplus-design-system-angular';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | boolean;
}

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate
): Observable<boolean> | boolean => {
  const dialog = inject(MatDialog);
  if (component.canDeactivate()) {
    const dialogRef = dialog.open(ConfirmModalComponent, {
      data: { title: 'Leave without saving?', description: 'You have unsaved changes on the page. Are you sure you would like to proceed?' }
    });
    return dialogRef.afterClosed().pipe(map(result => (result ? result.success : false)));
  }
  return true;
};
